var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.5c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5h-15c-.3 0-.5.2-.5.5v1Zm0 4c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5h-15c-.3 0-.5.2-.5.5v1Zm0-8c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5h-15c-.3 0-.5.2-.5.5v1ZM4.5 5c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5h-15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default ForwardRef;